import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import css from './NextButton.css'


export default function NextButton({
  isDisabled, isSubmit, handleClick, label, loading,
}) {
  return (
    <Button
      type="primary"
      htmlType={isSubmit ? 'submit' : 'button'}
      size="large"
      disabled={isDisabled}
      onClick={handleClick}
      className={css.button}
      loading={loading}
    >
      {label}
    </Button>
  )
}

NextButton.propTypes = {
  isDisabled: PropTypes.bool,
  isSubmit: PropTypes.bool.isRequired,
  handleClick: PropTypes.func,
  label: PropTypes.string,
  loading: PropTypes.bool,
}
NextButton.defaultProps = {
  isDisabled: false,
  handleClick: () => {},
  label: 'Next',
  loading: false,
}

export function BackButton({ handleClick }) {
  return (
    <Button
      type="secondary"
      htmlType="button"
      size="large"
      onClick={handleClick}
      className={css.backButton}
    >
      Back
    </Button>
  )
}

BackButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/common/NextButton.js